<template>
  <HeadlessLayout :sections="content" />
</template>

<script>
import SustainabilityPeopleContent from "@/content/SustainabilityPeople.json";
import HeadlessLayout from "@/layouts/HeadlessLayout.vue";

export default {
  name: "People",
  components: {
    HeadlessLayout,
  },
  data() {
    return {
      content: SustainabilityPeopleContent,
    };
  },
};
</script>
